import { useApiQuery } from '@apps/web/swr_data_fetching/use_api_query';
import { type Mode } from '@libraries/typescript/api_client';

// The outreach joined with its shifts, attempts, and responses. Heavy: for
// status polling use useOutreachDetail. Lives outside data_fetching_hooks so
// the v3 chat, whose import boundary excludes that module, can share the
// same request and cache entry as the outreach page and the sidebar.
export function useJoinedOutreach(
    organizationId: string | null,
    outreachId: string | null,
    traceParams: { readonly reason: string },
    mode?: Mode,
    options: {
        readonly enabled?: boolean;
        readonly refreshIntervalMs?: number;
    } = {},
) {
    return useApiQuery({
        path: '/organizations/{organization_id}/outreaches/joined/{outreach_id}',
        method: 'get',
        pathParams:
            organizationId && outreachId
                ? { organization_id: organizationId, outreach_id: outreachId }
                : undefined,
        enabled: (options.enabled ?? true) && !!organizationId && !!outreachId,
        select: (response) => response,
        reason: traceParams.reason,
        mode,
        refreshInterval: options.refreshIntervalMs,
    });
}
